import script from "./AdminDashboardLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardLayout.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboardLayout.vue?vue&type=style&index=0&id=a645f092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a645f092"]])

export default __exports__